"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueOrUndefined = exports.nullOrDefined = exports.nullable = exports.optional = void 0;
function optional(value) {
    return value ? value : undefined;
}
exports.optional = optional;
function nullable(value) {
    return value ? value : null;
}
exports.nullable = nullable;
/**
 * Convert a null, optional or defined value to either a null or the value.
 *
 * ie an undefined value is converted to valueIfUndefined.
 *
 * This is useful when you have a req.body which may be null,undefined or value
 * and you want to replace undefined with the previous value.
 *
 * @param value
 * @param valueIfUndefined
 * @returns
 */
function nullOrDefined(value, valueIfUndefined) {
    return value !== undefined ? value : valueIfUndefined;
}
exports.nullOrDefined = nullOrDefined;
/**
 * Convert a null, optional or defined value to either a undefined or the value.
 *
 * ie an null value is converted to valueIfNull.
 *
 * useful it you want to replace null with a default value (e.g. for prisma update)
 *
 * @param value
 * @param valueIfNull
 * @returns
 */
function valueOrUndefined(value, valueIfNull) {
    return value === null ? valueIfNull : value;
}
exports.valueOrUndefined = valueOrUndefined;
